(function ($, Drupal) {
    'use strict';
    Drupal.behaviors.kafFooter = {
      attach: (context) => {
        
        if (!$('.footer', context).length) {
          return;
        }
        
        var width = $(window).width();
        if (width <= 480) {
          //code for mobile devices
          $('.footer h3', context).click(function(){
            $(this).parents('.footer-menu').toggleClass('active-menu');
            $(this).parents('nav').find('ul').slideToggle("fast", function() {});
          });
        }
        
      }
    };

})(jQuery, Drupal);